export const Resolved = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="6" cy="6" r="4.5" fill="#ED544D" stroke="#ED544D" />
	</svg>
);

export const Unresolved = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="euyqs0djha" fill="#fff">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10zm2.47-5.482a.7.7 0 0 0-.94-1.036L5.22 6.58l-.784-.627a.7.7 0 0 0-.874 1.094l1.25 1a.7.7 0 0 0 .908-.029l2.75-2.5z"
			/>
		</mask>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10zm2.47-5.482a.7.7 0 0 0-.94-1.036L5.22 6.58l-.784-.627a.7.7 0 0 0-.874 1.094l1.25 1a.7.7 0 0 0 .908-.029l2.75-2.5z"
			fill="#038331"
		/>
		<path
			d="m8.518 4.53.74-.674-.74.673zm-.047.988.673.74-.673-.74zm-.942-1.036-.673-.74.673.74zM5.221 6.58l-.625.781.666.533.632-.574-.673-.74zm-.784-.627-.624.781.624-.78zm-.984.11.781.624-.78-.624zm.11.984-.625.78.625-.78zm1.25 1 .624-.781-.624.78zm.908-.029-.673-.74.673.74zM10 6a4 4 0 0 1-4 4v2a6 6 0 0 0 6-6h-2zM6 2a4 4 0 0 1 4 4h2a6 6 0 0 0-6-6v2zM2 6a4 4 0 0 1 4-4V0a6 6 0 0 0-6 6h2zm4 4a4 4 0 0 1-4-4H0a6 6 0 0 0 6 6v-2zm1.778-4.798a.3.3 0 0 1 .02-.424l1.346 1.48a1.7 1.7 0 0 0 .114-2.402l-1.48 1.346zm.424.02a.3.3 0 0 1-.424-.02l1.48-1.346a1.7 1.7 0 0 0-2.402-.114l1.346 1.48zM5.894 7.32l2.308-2.098-1.346-1.48L4.548 5.84l1.346 1.48zm-2.081-.586.783.627L5.846 5.8l-.784-.626-1.25 1.561zm.421-.047a.3.3 0 0 1-.421.047l1.249-1.561a1.7 1.7 0 0 0-2.39.265l1.562 1.25zm-.047-.421a.3.3 0 0 1 .047.421L2.673 5.438a1.7 1.7 0 0 0 .265 2.39l1.25-1.562zm1.25 1-1.25-1-1.249 1.561 1.25 1 1.25-1.561zm-.389.012a.3.3 0 0 1 .39-.012l-1.25 1.561a1.7 1.7 0 0 0 2.206-.07L5.048 7.279zm2.75-2.5-2.75 2.5 1.346 1.48 2.75-2.5-1.346-1.48z"
			fill="#038331"
			mask="url(#euyqs0djha)"
		/>
	</svg>
);
